import { createContext } from '@lit/context';
export const organisationContext = createContext(Symbol('organisation'));
export const locationListingsContext = createContext(Symbol('listingsLocation'));
export const supportListingsContext = createContext(Symbol('listingsSupport'));
export const memberContext = createContext(Symbol('member'));
